<template>
    <el-date-picker
        size="small"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :value="value"
        :editable="false"
        v-bind="$attrs"
        @input="input"
    />
</template>

<script>
export default {
    name: 'XxDatepicker',

    props: {
        value: {
            required: true
        }
    },
    data() {
        return {
            // clazz: this.$attrs.type === 'daterange' ? 'range' : 'date'
        };
    },
    methods: {
        input(val) {
            this.$emit('input', val);
        }
    },
    created() { }
};
</script>
